export const redeemPointsSelector = (state) =>
  state.redeemPoints ? state.redeemPoints : {};

export const redeemPointsItemsSelector = (state) =>
  state?.redeemPoints?.items ? state.redeemPoints.items : [];
